module.exports = __webpack_public_path__ + "static/media/23-WaterHeatExchanger - No cool - No heat.3c0b8942.png";